import React from "react";
// import { Link } from "react-router-dom";
import { Link } from "react-scroll";


const OffCanvasMenuWms = () => {
  const featureList = [
    { title: "Product Highlights", href: "productHighlights" },
    { title: "Capabilities", href: "capabilities" },
    { title: "Garage Controls", href: "garageControls" },
  ];
  return (
    <div className="offcanvas-body">
      <ul className="nav col-12 col-md-auto justify-content-center main-menu">
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle d-flex justify-content-between"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Features
          </a>
          <div className="dropdown-menu border-0 rounded-custom shadow py-0 bg-white">
            <div className="dropdown-grid rounded-custom width-full">
              <div className="dropdown-grid-item">
                {featureList.map((featureListItem, i) => (
                  <div key={i + 1} className="d-flex">
                    <Link
                      to={featureListItem.href}
                      smooth={true}
                      duration={600}
                      offset={-80}
                      className="nav-link text-muted"
                    >
                       <a
                        className="dropdown-link px-0"
                        aria-label="Close"
                        data-bs-dismiss="offcanvas"
                      >
                        {/* <span className="me-2">{navLink.icon}</span>
                        <span className="drop-title mb-0"> */}
                                  {featureListItem.title}{" "}
                        {/* </span> */}
                      </a>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </li>
        <li data-bs-dismiss="offcanvas" aria-label="Close">
          <Link
            to="pricing"
            smooth={true}
            duration={600}
            offset={-80}
            className="nav-link cursor-pointer"
          >
            Pricing
          </Link>
        </li>

        <li>
          <a
            href="https://wms.senertech.in/login"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            Sign In
          </a>
        </li>

        <li>
          <a
            href="https://wms.senertech.in/register"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            Register
          </a>
        </li>

      </ul>
    </div>
  );
};

export default OffCanvasMenuWms;
